import * as React from 'react';
interface VROtherProps {
  onItemClick?: (event: React.MouseEvent<HTMLElement>) => void,
  thumb?: boolean,
  thumbWidth: number,
  thumbHeight: number
}
export default function VR(props: PcMainImage.CustomHomeData & VROtherProps) {
  if (props.thumb) return (
    <div className="vr-thumb" onClick={props.onItemClick}>
      <div className="vr-place-holder">
        <div className="thumb-shadow" style={{ width: props.thumbWidth, height: props.thumbHeight }}></div>
        <img src="https://img.alicdn.com/tfs/TB1s1HzmZieb18jSZFvXXaI3FXa-20-20.svg" alt="vr-icon" className="vr-icon" />
      </div>
      <img src={props.customHome.cover} alt="image" />
    </div>
  );
  return (
    <a href={props.customHome.url} target="_blank" className="vr-big-image">
      <img src="https://img.alicdn.com/tfs/TB1gxyV2AL0gK0jSZFAXXcA9pXa-78-78.svg" alt="vr-icon" className="vr-icon-big" />
      <img src={props.customHome.cover} alt="image" />
    </a>
  );
}

